module.exports = __webpack_public_path__ + "static/media/New-Vidami-Logo.41ed350d.png";